import { render, staticRenderFns } from "./MonitorCteDetalhes.vue?vue&type=template&id=32bfa54d"
import script from "./MonitorCteDetalhes.vue?vue&type=script&lang=js"
export * from "./MonitorCteDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports